import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './Warning.styles';

interface WarningIconProps extends WithStyles<typeof styles> {
  color?: string;
  onClick?: () => void;
}

const WarningIconComponent: FC<WarningIconProps> = ({ classes, color, onClick }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      onClick={onClick}
      classes={{ root: classes.root }}
    >
      <path
        d="M7.99976 5.99999V8.66665M7.99976 11.3333H8.00642M7.07663 2.59447L1.59338 12.0655C1.28924 12.5909 1.13717 12.8535 1.15965 13.0691C1.17925 13.2571 1.27776 13.428 1.43067 13.5392C1.60597 13.6667 1.90948 13.6667 2.5165 13.6667H13.483C14.09 13.6667 14.3935 13.6667 14.5688 13.5392C14.7217 13.428 14.8203 13.2571 14.8399 13.0691C14.8623 12.8535 14.7103 12.5909 14.4061 12.0655L8.92288 2.59447C8.61983 2.07102 8.46831 1.8093 8.27062 1.7214C8.09818 1.64473 7.90133 1.64473 7.72889 1.7214C7.5312 1.8093 7.37968 2.07102 7.07663 2.59447Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const WarningIcon = withStyles(styles)(WarningIconComponent);
